export const defaultObjectProps = {
    fill: 'rgb(30, 139, 195)',
    opacity: 1,
    backgroundColor: null,
    strokeWidth: 0.1,
    stroke: '#000',
    shadow: {
        color: '#000',
        blur: 3,
        offsetX: -1,
        offsetY: 0,
    },
};
